function w3_load_js_uri(script) {
    const newScript = document.createElement("script");
    const attrs = script.attributes;

    for (let i = 0; i < attrs.length; i++) {
      const attr = attrs[i];
      if (attr.name !== "type" && attr.name !== "data-src") {
        newScript.setAttribute(attr.name, attr.value);
      }
      if (attr.name === "data-type") {
        newScript.setAttribute("type", attr.value);
      }
    }

    newScript.src = script.getAttribute("data-src");
    script.parentNode.insertBefore(newScript, script.nextSibling);
    script.parentNode.removeChild(script);

    return newScript;
  }

  function w3_load_inline_js(script) {
    const newScript = document.createElement("script");

    for (let i = 0; i < script.attributes.length; i++) {
      const attr = script.attributes[i];
      if (attr.name !== "type") {
        newScript.setAttribute(attr.name, attr.value);
      }
      if (attr.name === "data-type") {
        newScript.setAttribute("type", attr.value);
      }
    }

    newScript.innerHTML = script.innerHTML;
    script.parentNode.insertBefore(newScript, script.nextSibling);
    script.parentNode.removeChild(script);
  }

  function lazyLoadScripts() {
    const scripts = document.querySelectorAll('script[type="lazyload2"]');
    if (scripts.length === 0) return;

    const script = scripts[0];

    if (script.hasAttribute("data-src")) {
      const newScript = w3_load_js_uri(script);
      newScript.onload = lazyLoadScripts;
      newScript.onerror = lazyLoadScripts;
    } else {
      w3_load_inline_js(script);
      lazyLoadScripts();
    }
  }

function loadResponsiveImages(selector = '.imageLoad') {
    const isMobile = window.innerWidth < 768;
    document.querySelectorAll(selector).forEach(img => {
      const desktopSrc = img.getAttribute('data-srcdesktop');
      const mobileSrc = img.getAttribute('data-srcmobile');
      const srcset = img.getAttribute('data-dsrcset') || img.getAttribute('data-srcset');
      const width = img.getAttribute('data-width');
      const height = img.getAttribute('data-height');

      if (img.classList.contains('imageLoad')) {
        img.src = isMobile ? mobileSrc : desktopSrc;
        if (srcset) img.srcset = srcset;
        if (width) img.setAttribute('width', width);
        if (height) img.setAttribute('height', height);
        img.classList.remove('imageLoad');
      }
    });
  }

  function loadResponsiveImages2(selector = '.imageLoad2') {
    const isMobile = window.innerWidth < 768;
    document.querySelectorAll(selector).forEach(img => {
      const desktopSrc = img.getAttribute('data-srcdesktop');
      const mobileSrc = img.getAttribute('data-srcmobile');
      const srcset = img.getAttribute('data-dsrcset') || img.getAttribute('data-srcset');
      const width = img.getAttribute('data-width');
      const height = img.getAttribute('data-height');

      if (img.classList.contains('imageLoad')) {
        img.src = isMobile ? mobileSrc : desktopSrc;
        if (srcset) img.srcset = srcset;
        if (width) img.setAttribute('width', width);
        if (height) img.setAttribute('height', height);
        img.classList.remove('imageLoad');
      }
    });
  }
function triggerImageLoad() {
  loadResponsiveImages();

  document.querySelector('.mobile__search__area')?.classList.add('show');

  // Find all elements with class 'TextHidden' and add 'showData' class to each
  document.querySelectorAll('.TextHidden').forEach(el => {
  if (el.style.visibility === 'hidden') {
    el.style.removeProperty('visibility');
  }
});
const aliaPopup = document.querySelector('[aria-label="Alia popup"]');
  if (aliaPopup) {
    aliaPopup.style.display = '';
    aliaPopup.classList.add('show-visible');
  }
const mainBody = document.querySelector('body');
   if (mainBody) {
  
    mainBody.classList.add('scroll');
  }
  // Handle <chat-widget class="hydrated">
  const chatWidget = document.querySelector('chat-widget.hydrated');
  if (chatWidget) {
    chatWidget.style.display = '';
    chatWidget.classList.add('show-visible');
  }

  window.removeEventListener('scroll', triggerImageLoad);
}
  function wnw_init() {
    triggerImageLoad();
  }

document.addEventListener("DOMContentLoaded", () => {
  lazyLoadScripts();
  });
  

    window.addEventListener("scroll", loadResponsiveImages2, { once: true });
    window.addEventListener("mousemove", loadResponsiveImages2, { once: true });
    window.addEventListener("touchstart", loadResponsiveImages2, { once: true });
  window.addEventListener("scroll", wnw_init, { once: true });
  window.addEventListener("mousemove", wnw_init, { once: true });
  window.addEventListener("touchstart", wnw_init, { once: true });
  document.addEventListener("DOMContentLoaded", function () {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    if (loadMoreBtn) {       
      loadMoreBtn.addEventListener('click', function () {
        setTimeout(function () {
          loadResponsiveImages2();
          loadResponsiveImages();
        }, 2000);
      });
    } else {
      console.error("Load More button not found");
    }
  });